import React, { useEffect, useState } from "react";
import { Form, InputGroup, Modal } from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import "./Login_Modal.css";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import PasswordChecklist from "react-password-checklist";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Reset_Password_Modal from "../reset_password_modal/Reset_Password_Modal";
import Black_Btn from "../../common_btn/black_btn/Black_Btn";
import "react-phone-input-2/lib/style.css";
import PhoneInput from "react-phone-input-2";
import Success_Modal from "../success_modal/Success_Modal";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  sendMobileOtp,
  sendMobileOtpSingUp,
  UserLogin,
  userSignUp,
  verifyOtp,
} from "../../../../features/auth/authSlice";
import { getAllCart } from "../../../../features/cart/cartSlice";
import { myAccount } from "../../../../features/my_account/Slice";
import { text } from "@fortawesome/fontawesome-svg-core";
import { CountryCode } from "../../../../features/master/masterSlice";
import OtpInput from "react-otp-input";

const SingUp_Modal = ({
  onHide,
  setShowAccountCreted,
  showSignUp,
  setShowSignUp,
  ...props
}) => {
  const {
    control,
    register,
    handleSubmit,
    setError,
    watch,
    formState: { errors },
  } = useForm();

  const options = [
    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },

    { value: "+91", label: "+91" },
  ];

  const [showSuccessModal, setShowSucsessModal] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");

  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordOne, setShowPasswordOne] = useState(false);
  const [iconOne, setIconOne] = useState(faEyeSlash);
  const [iconTwo, setIconTwo] = useState(faEyeSlash);

  const togglePasswordVisibility = (field) => {
    if (field === "password") {
      setShowPassword(!showPassword);
      setIconOne(showPassword ? faEyeSlash : faEye);
    } else if (field === "reenterPassword") {
      setShowPasswordOne(!showPasswordOne);
      setIconTwo(showPasswordOne ? faEyeSlash : faEye);
    }
  };

  const dispatch = useDispatch();
  const isSignin = useSelector((state) => state.auth.is_signin);

  //loginnn-------------------

  //signup----------
  const onSubmit = async (data) => {
    if (!verifyStatus) {
      setMobileNoError("Verify Mobile Number");
      return;
    }

    const res = await dispatch(userSignUp(data));

    if (res.meta?.requestStatus === "fulfilled") {
      setSuccessMsg("Sign Up Succesfully !");
      setShowSucsessModal(true);
      onHide();
      setTimeout(() => {
        navigate("/");
        setShowSucsessModal(false);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
  
      if (res.payload?.errors?.email) {
        setError("email", {
          type: "manual",
          message: res.payload?.errors?.email,
        });
      }
      if (res.payload?.errors?.contact_no) {
        setError("contact_no", {
          type: "manual",
          message: res.payload?.errors?.contact_no,
        });
      }
    }
  };

  const user = useSelector((state) => state.myaccount.addMyaccount);

  useEffect(() => {
    if (user?.id) {
      dispatch(myAccount());
    }
  }, []);

  const countryCode = useSelector((state) => state.master.country_code);

  useEffect(() => {
    dispatch(CountryCode());
  }, []);

  const [otp, setOtp] = useState("");
  const [mobileNoError, setMobileNoError] = useState("");
  const [showmobOtp, setShowmobOtp] = useState(false);
  const [otpError, setOtpError] = useState("");
  const mobileNo = watch("contact_no");
  const [timer, setTimer] = useState(0);
  const sendOtp = async (e) => {
    e.preventDefault();

    if (!mobileNo) {
      setMobileNoError("Please Enter Contact No");
      return;
    }
    if (!mobileNo || mobileNo?.length < 10) {
      setMobileNoError("Please Enter Valid Mobile No");
      return;
    }
    try {
      const data = { contact_no: mobileNo };
      const res = await dispatch(sendMobileOtpSingUp(data));

      if (res.meta?.requestStatus === "fulfilled") {
        // handleNext();
        setShowmobOtp(true);
        setTimer(60);
      } else if (res.meta?.requestStatus === "rejected") {
        setMobileNoError(res.payload?.errors);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetmobOtp = (e) => {
    e.preventDefault();
    // setMobileNoError("");
    sendOtp();
  };

  const [verifyStatus, setVerifyStatus] = useState(false);
  const [selectedCode, setSelectedCode] = useState(null);
  const handleVerifyOtp = async () => {
    if (!otp) {
      setOtpError("Provide Four Digit OTP");
      return;
    }
    try {
      const data = { contact_no: mobileNo, otp };
      const res = await dispatch(verifyOtp(data)); // <-- redux thunk action

      if (res.meta?.requestStatus === "fulfilled") {
        setVerifyStatus(true);
        setShowmobOtp(false);
        setMobileNoError("");
        setOtpError("");
      } else if (res.meta?.requestStatus === "rejected") {
        setOtpError(
          res.payload?.errors || "An error occurred. Please try again."
        );
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      setOtpError("An unexpected error occurred. Please try again.");
    }
  };

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      clearInterval(interval);
    }
    return () => clearInterval(interval);
  }, [timer]);



  return (
    <>
      <div className="signup_div">
        <div className="login_form_div">
          <Form>
            <div className="row">
              <div className="col-md-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>First Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter First name"
                    {...register("Name", {
                      required: "Name is required",
                    })}
                  />
                  {errors?.Name && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.Name?.message}
                    </div>
                  )}
                </Form.Group>
              </div>
              <div className="col-md-6">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Last Name</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter Last name"
                    {...register("LastNamel", {
                      required: "Last Name is required",
                    })}
                  />
                  {errors.LastNamel && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.LastNamel?.message}
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>

            <Form.Group className="gray_input_group input_group">
              <Form.Label>Email ID</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter your email "
                {...register("email", {
                  required: "Email is required",
                  pattern: {
                    value: /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                    message: "Email Address Invalid",
                  },
                })}
              />
              {errors?.email && (
                <sup className="text-danger">{errors?.email?.message}</sup>
              )}
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="Enter Password"
                  {...register("password", {
                    required: "Password is required",
                    minLength: {
                      value: 8,
                      message: "Password must be at least 8 characters long",
                    },
                    pattern: {
                      value: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
                      message:
                        "Password must contain at least one uppercase letter, one lowercase letter, and one number",
                    },
                  })}
                  onChange={(e) => setPassword(e.target.value)}
                />
                {errors?.password && (
                  <sup className="text-danger">{errors?.password?.message}</sup>
                )}
                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconOne}
                    className="icon"
                    onClick={() => togglePasswordVisibility("password")}
                  />
                </div>
              </div>
            </Form.Group>

            <Form.Group className="gray_input_group input_group">
              <Form.Label className="label_text">Confirm Password</Form.Label>
              <div className="password_holder">
                <Form.Control
                  placeholder="Confirm Password"
                  type={showPasswordOne ? "text" : "password"}
                  name="re_password"
                  {...register("re_password", {
                    required: "Re-Enter Password  is required",
                  })}
                  onChange={(e) => setPasswordAgain(e.target.value)}
                />

                <div className="eye-icc">
                  <FontAwesomeIcon
                    icon={iconTwo}
                    className="icon"
                    onClick={() => togglePasswordVisibility("reenterPassword")}
                  />
                </div>
                {errors?.re_password && (
                  <sup className="text-danger">
                    {errors?.re_password?.message}
                  </sup>
                )}
              </div>
            </Form.Group>

            {password && (
              <div className="password_check_list">
                <PasswordChecklist
                  rules={[
                    "minLength",
                    "specialChar",
                    "number",
                    "capital",
                    "match",
                  ]}
                  minLength={8}
                  value={password}
                  valueAgain={passwordAgain}
                  onChange={(isValid) => {}}
                  style={{
                    fontSize: "10px",
                    padding: "4px",
                    margin: "0",
                  }}
                />
              </div>
            )}

            <div className="row mt-2">
              <div className="col-lg-6 col-sm-12">
                <Form.Group className="gray_input_group input_group Contact_field_holder">
                  <Form.Label>Contact</Form.Label>
                  {/* <Controller
                    country="in"
                    className="phone_input"
                    name="contact_no"
                    control={control}
                    rules={{
                      required: "contact_no is required",
                      minLength: {
                        value: 10,
                        message: "Number should be at least 10 characters",
                      },
                    }}
                    render={({ field }) => (
                      <PhoneInput
                        country="in"
                        {...field}
                        onChange={(value) => field.onChange(value)}
                        type="text"
                        placeholder="Enter Mobile Number"
                        maxLength={10}
                      />
                    )}
                  /> */}

                  <InputGroup className="mb-3">
                    <div>
                      <InputGroup.Text id="basic-addon1">
                        <Controller
                          name="country_code_id" // name of the field
                          {...register("country_code_id", {
                            required: "Select Country Code",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.country_code_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={countryCode}
                              onChange={(val) => {
                                field.onChange(val);
                                setSelectedCode(val); // 👈 store selection
                              }}
                            />
                          )}
                        />
                      </InputGroup.Text>
                      {errors?.country_code_id && (
                        <sup className="text-danger">
                          {errors?.country_code_id?.message}
                        </sup>
                      )}
                    </div>

                    <div className="contact_number_field_holder">
                      <Form.Control
                        placeholder="Enter Contact Number"
                        aria-label="Contact"
                        aria-describedby="basic-addon1"
                        type="text"
                        readOnly={verifyStatus}
                        maxLength={selectedCode?.length || 10} // 👈 fallback 10
                        {...register("contact_no", {
                          required: "Contact number is required",
                          validate: (value) => {
                            if (!selectedCode)
                              return "Select country code first";
                            if (value.length !== selectedCode.length) {
                              return `Contact number must be ${selectedCode.length} digits`;
                            }
                            return true;
                          },
                        })}
                        onKeyPress={(e) => {
                          if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                          }
                        }}
                      />

                      {/* <Form.Control
                      placeholder="Enter Contact Number"
                      aria-label="Contact"
                      aria-describedby="basic-addon1"
                      type="text"
                      maxLength={10}
                      readOnly={verifyStatus}
                      {...register("contact_no", {
                        required: "Contact number is required",
                        pattern: {
                          value: /^[0-9]{10}$/,
                          message: "Contact number must be 10 digits",
                        },
                      })}
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}
                    /> */}

                      <div className="otpbtnholder">
                        {verifyStatus ? (
                          <p className="verify">Verify</p>
                        ) : (
                          <>
                            {!showmobOtp && (
                              <button className="sendotp" onClick={sendOtp}>
                                Send OTP
                              </button>
                            )}

                            {timer === 0 && showmobOtp && (
                              <button className="sendotp" onClick={sendOtp}>
                                Resend OTP
                              </button>
                            )}
                          </>
                        )}
                      </div>

                      {errors?.contact_no && (
                        <sup className="text-danger">
                          {errors?.contact_no?.message}
                        </sup>
                      )}
                    </div>
                  </InputGroup>

                  {mobileNoError && (
                    <span className="text-danger">{mobileNoError}</span>
                  )}

                  {/* <div className="otpbtnholder">
                    {verifyStatus ? (
                      <p className="verify">Verify</p>
                    ) : (
                      <button className="sendotp" onClick={sendOtp}>
                        Send Otp
                      </button>
                    )}
                  </div> */}
                  {showmobOtp && timer > 0 && (
                    <div className="otp_inputes">
                      <OtpInput
                        value={otp}
                        onChange={setOtp}
                        numInputs={4}
                        renderSeparator={<span>-</span>}
                        renderInput={(props) => <input {...props} />}
                      />

                      <button
                        className="verifyotpbtn"
                        onClick={(e) => {
                          e.preventDefault();
                          handleVerifyOtp();
                        }}
                      >
                        Verify
                      </button>
                      {timer > 0 && (
                        <div className="timer_holder">
                          <p>{timer} Secends</p>
                        </div>
                      )}
                    </div>
                  )}
                  {otpError && <span className="text-danger">{otpError}</span>}
                </Form.Group>
              </div>

              <div className="col-lg-6 col-sm-12">
                <Form.Group className="gray_input_group input_group">
                  <Form.Label>Date of Birth</Form.Label>
                  <Form.Control
                    type="date"
                    max={new Date().toISOString().split("T")[0]} // disable future dates
                    {...register("date", {
                      required: "Date of birth is required",
                      validate: {
                        notFuture: (value) =>
                          new Date(value) <= new Date() ||
                          "Future date not allowed",
                      },
                    })}
                  />
                  {errors?.date && (
                    <div style={{ fontSize: "13px", color: "red" }}>
                      {errors?.date?.message}
                    </div>
                  )}
                </Form.Group>
              </div>
            </div>
          </Form>
        </div>
        <div className="d-md-flex  align-items-center gap-3 ">
          <div className="btn_holder">
            <Black_Btn btnText="Sign Up" onClick={handleSubmit(onSubmit)} />
          </div>

          <p className="dark_text">
            Already have an account?{" "}
            <span
              className="link_text"
              onClick={() => {
                setShowSignUp(false);
              }}
            >
              Log In
            </span>
            .
          </p>
        </div>
        <div className="text-center note_holder mt-5">
          <Form.Check
            type={"checkbox"}
            label={
              <>
                By continuing, I agree to ChefCuts{" "}
                <Link to={"/privacy-policy"}>
                  <b className="linking">Terms of Use</b>{" "}
                </Link>{" "}
                &{" "}
                <Link to={"/terms-conditions"}>
                  <b className="linking">Privacy Policy</b>
                </Link>
              </>
            }
          />
        </div>
      </div>
    </>
  );
};

export default SingUp_Modal;
